<template>
  <div class="text-center mt-20">
    <h1 class="text-4xl font-bold mb-4">404 - Page Not Found</h1>
    <p class="text-gray-600">요청하신 페이지를 찾을 수 없습니다.</p>
  </div>
</template>
